var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPieChartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6832 6.62656C15.7165 8.6599 15.7165 11.9599 13.6832 13.9932C11.6498 16.0266 8.34984 16.0266 6.3165 13.9932C4.28317 11.9599 4.28317 8.6599 6.3165 6.62656C8.34984 4.59323 11.6498 4.59323 13.6832 6.62656Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.87486 18.6581C6.79986 18.6581 6.71653 18.6414 6.64153 18.6164C4.76653 17.8664 3.24986 16.5414 2.2332 14.7914C1.24986 13.0831 0.858196 11.1497 1.11653 9.18306C1.1582 8.84139 1.4832 8.59972 1.81653 8.64139C2.1582 8.68306 2.39986 8.99972 2.3582 9.34139C2.14153 11.0331 2.47486 12.6997 3.31653 14.1664C4.1832 15.6664 5.49153 16.8081 7.09986 17.4497C7.41653 17.5831 7.57486 17.9414 7.44986 18.2664C7.3582 18.5081 7.11653 18.6581 6.87486 18.6581Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.87517 4.35651C4.69184 4.35651 4.5085 4.27318 4.3835 4.11484C4.16684 3.84818 4.21684 3.45651 4.49184 3.23984C6.07517 1.99818 7.9835 1.33984 10.0002 1.33984C11.9668 1.33984 13.8418 1.97318 15.4168 3.17318C15.6918 3.38151 15.7418 3.77318 15.5335 4.04818C15.3252 4.32318 14.9335 4.37318 14.6585 4.16484C13.3002 3.13151 11.6918 2.58984 10.0002 2.58984C8.26684 2.58984 6.62517 3.15651 5.2585 4.22318C5.14184 4.31484 5.0085 4.35651 4.87517 4.35651Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1248 18.6575C12.8748 18.6575 12.6414 18.5075 12.5414 18.2659C12.4164 17.9492 12.5664 17.5825 12.8914 17.4492C14.4998 16.7992 15.8081 15.6659 16.6748 14.1659C17.5248 12.6992 17.8581 11.0325 17.6331 9.3492C17.5914 9.00754 17.8331 8.69087 18.1748 8.6492C18.5081 8.60754 18.8331 8.8492 18.8748 9.19087C19.1248 11.1492 18.7414 13.0909 17.7581 14.7992C16.7498 16.5492 15.2248 17.8659 13.3498 18.6242C13.2831 18.6409 13.2081 18.6575 13.1248 18.6575Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPieChartIcon);
export default __webpack_public_path__ + "static/media/pie-chart-icon.a7df9bef5063a04ac37220afdcd86f86.svg";
export { ForwardRef as ReactComponent };